const config = {
  API_URL: process.env.REACT_APP_API_URL,
  API_KEY: process.env.REACT_APP_API_KEY,

  S3region: "ap-south-1", //  AWS region
  S3IdentityPoolId: "ap-south-1:2854f7d0-a2c1-45a3-90bf-9d3ad5812ae7", //  Identity Pool ID
  
  S3AccessKeyId: "AKIA6GBMGQ24VRUQVRDM", // S3 Access Key ID
  S3SecretAccessKey: "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", //  S3 secret access key
  
  S3BucketName: "freedomtv", //  S3 bucket name
};
export default config;
